export function resolveAiInputUploadPromise(
    startDirectUpload: () => Promise<string>,
    signedIdPromise?: Promise<string | null> | null,
): Promise<string> {
    const upload = signedIdPromise || startDirectUpload()

    return upload.then(signedId => {
        if (!signedId) throw new Error('Attachment upload returned no file id')
        return signedId
    })
}
